import { IdiomaService } from './../providers/idioma/idioma.service';
import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';
import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-formulario-crear-seccion',
  templateUrl: './FormularioCrearSeccion.component.html'
})

export class FormularioCrearSeccionComponent implements OnDestroy{

  @Input() nodos: Array<any> = [];

  @Output() onSeccionCreada: EventEmitter<any> = new EventEmitter();

  public msgs: String = '';
  spinner: HTMLElement;

  constructor(
      private entityManagerProvider: EntityManagerProvider,
	  public authService: AuthenticationService,
	  public idiomaService: IdiomaService,
	  private translate: TranslateService
	) {
			// Inicializamos Spinner
			this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
			this.spinner.style.display = 'none';

  }

	ngOnDestroy(): void {
		this.entityManagerProvider.RejectChanges();
    }

    guardable(){
        return this.nodos && this.nodos.length > 3;
    }


	cancelar(){
		this.onSeccionCreada.emit(false);
		this.authService.relogin();
	}

	guardar(){
		this.spinner.style.display = 'inherit';
    	this.onSeccionCreada.emit(true);
		this.authService.relogin();

	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioCrearSeccion.component.ts